import React from "react";
import { Box, Typography } from "@mui/material";

// Props: isVeg = true | false, size (default 32px)
const VegNonVegTag = ({ isVeg, size = 32, showLabel = true, cake = true }) => {
  const color = isVeg ? "#3ca53c" : "#e53935";
  const borderColor = color;
  let label;
  if (cake) {
    label = isVeg ? "Eggless" : "Egg";
  } else {
    label = isVeg ? "VEG" : "NON-VEG";
  }
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Box
        sx={{
          border: `2px solid ${borderColor}`,
          borderRadius: "4px",
          width: size,
          height: size,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 1,
          background: "#fff",
        }}
      >
        {isVeg ? (
          // Green circle for veg
          <Box
            sx={{
              bgcolor: color,
              width: size * 0.6,
              height: size * 0.6,
              borderRadius: "50%",
            }}
          />
        ) : (
          // Red triangle for non-veg
          <Box
            component="span"
            sx={{
              width: 0,
              height: 0,
              borderLeft: `${size * 0.3}px solid transparent`,
              borderRight: `${size * 0.3}px solid transparent`,
              borderBottom: `${size * 0.6}px solid ${color}`,
              borderRadius: 0,
            }}
          />
        )}
      </Box>
      {showLabel && (
        <Typography
          sx={{
            fontWeight: "bold",
            color,
            fontFamily: "serif",
            fontSize: size * 0.6,
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default VegNonVegTag;
